import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const itemGroupUpdateAtom = createMutationAtomFactory(
  'settings.itemGroupUpdate',
  (params: {
    id: string;
    parentId?: string | null;
    name?: string | null;
    number?: string | null;
    description?: string | null;
    notes?: string | null;
    defaultPricingUnit?: string | null;
    colorHue?: number | null;
  }) => ({
    inventoryItemGroupUpdate: {
      __args: {
        id: params.id,
        input: {
          parentId: params.parentId,
          name: params.name,
          number: params.number,
          description: params.description,
          notes: params.notes,
          defaultPricingUnit: params.defaultPricingUnit,
          colorHue: params.colorHue,
        },
      },
      id: true,
      name: true,
      number: true,
      colorHue: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
